'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default function () {
    return {
        restrict: 'A',
        template: require('../../../view/table.html'),
        transclude: true,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            def: '=?myDef'
        },
        controller: ['$scope', '$utils', 'StatusService', '$security', 'AuditService',
            function ($scope, $utils, StatusService, $security, AuditService) {

                $scope.getStatusDisplayName = StatusService.getDisplayName;
                $scope.refresh = refresh;
                $scope.dblClick = dblClick;
                $scope.select = select;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;

                $scope.columns = [{
                    name: "Когда",
                    data: "actionTime",
                    type: "datetime"
                }, {
                    name: "Кто",
                    data: "userName"
                }, {
                    name: "Действие",
                    data: "actionName"
                }, {
                    name: "Таблица",
                    data: "dataSetName"
                }, {
                    name: "Идентификатор объекта",
                    data: "objectId"
                }, {
                    name: "Дополнительная информация",
                    data: "addInfo"
                }];

                $scope.searching = {
                    isSearch: $scope.isSearch,
                    filter: null
                };

                $scope.pagination = {
                    isPaging: $scope.isPaging,
                    page: 1,
                    size: $scope.isPaging ? 10 : null,
                    totalPages: null,
                    totalItems: null
                };

                // тулбокс таблицы
                $scope.toolbox = {
                    // кнопки на панели управления
                    buttons: {
                        // обновление таблицы
                        refresh: {
                            show: () => true,
                            click: $scope.refresh,
                            disabled: () => false,
                        }
                    }
                };

                // получение данных
                refresh();

                // region Function

                /**
                 * Получение всех записей
                 * @returns {*}
                 */
                function getItems() {
                    return $scope.items;
                }

                /**
                 * Выбран ли элемент!
                 * @param item проверяемый элемент
                 * @returns bool
                 */
                function isSelect(item) {
                    return equals(getSelected(), item);
                }

                /**
                 * Выбрать элемент
                 * @param item выбираемый элемент
                 */
                function select(item) {
                    if (!$scope.isSelect(item)) {
                        $scope.selectedItem = angular.copy(item);
                    } else {
                        $scope.selectedItem = angular.copy({});
                    }
                }

                /**
                 * Двойное нажатие на запись в таблице
                 * @param item данные записи
                 */
                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table' :
                            $scope.toolbox.buttons.edit.click(item);
                            break;
                        case 'select' :
                            $scope.ok(item);
                            break;
                    }
                }

                /**
                 * Получение фильтров
                 * @returns {Array}
                 */
                function getFilters() {
                    let filters = [];
                    if (Array.isArray($scope.filters)) {
                        filters = filters.concat($scope.filters);
                    }
                    return filters;
                }

                /**
                 * Получение поиска
                 * @returns {Array}
                 */
                function getSearchs() {
                    let searchs = [];
                    if ($scope.isSearch) {
                        if ($scope.searching.filter != null && !($scope.searching.filter.length < 1)) {
                            searchs.push("'userName':'" + $scope.searching.filter + "'");
                            searchs.push("'objectId':'" + $scope.searching.filter + "'");
                            searchs.push("'addInfo':'" + $scope.searching.filter + "'");
                        }
                    }
                    return searchs;
                }

                /**
                 * Выбрана ли запись
                 * @returns {boolean}
                 */
                function isSelected() {
                    return $scope.selectedItem != null && $scope.selectedItem.id != null && !angular.equals($scope.selectedItem, {});
                }

                /**
                 * Проверка элементов на равенство
                 * @param i1
                 * @param i2
                 * @returns {*}
                 */
                function equals(i1, i2) {
                    if (i1 == i2) {
                        return true;
                    }
                    if (i1 != null && i2 != null) {
                        return angular.equals(i1.id, i2.id);
                    }
                    return false;
                }

                /**
                 * Получить выбранный элемент
                 * @returns {{}|*}
                 */
                function getSelected() {
                    return $scope.selectedItem;
                }

                /**
                 * Обновить данные таблицы
                 */
                function refresh() {
                    AuditService.api.get({
                        filters: getFilters(),
                        searchs: getSearchs(),
                        sorts: ['version:DESC'],
                        page: $scope.pagination.page,
                        size: $scope.pagination.size
                    }, function (data) {
                        $scope.items = data._embedded;
                        if (isSelected()) {
                            if ($scope.items.every(i => !equals(i, getSelected()))) {
                                $scope.selectedItem = {};
                            } else {
                                $scope.selectedItem = angular.copy($scope.items.find(i => equals(i, getSelected())));
                            }
                        }
                        if ($scope.pagination.isPaging) {
                            $scope.pagination.totalPages = data.page.totalPages;
                            $scope.pagination.totalItems = data.page.totalElements;
                        }
                    });
                }

                // endregion

                // region Watchers

                $scope.$watch('filters', function () {
                    $scope.refresh();
                });

                // endregion

            }]
    };
}
